import {useState} from "react";
import PropTypes from "prop-types";
import {Alert as BootstrapAlert} from "react-bootstrap";

const getNodeText = (node) => {
  if (node == null) return "";
  if (typeof node === "string" || typeof node === "number") return node.toString();
  if (Array.isArray(node)) return node.map(getNodeText).join("");
  if (typeof node === "object" && node.props) return getNodeText(node.props.children);
  return "";
};

const Alert = (
  {
    variant,
    margin,
    children = <></>,
    dismissible = false,
    onClose = () => {},
    className,
    title
  }
) => {
  const [show, setShow] = useState(true);

  if (!show) return null;

  let icon;
  switch (variant) {
    case 'danger':
      icon = <i className="bi bi-exclamation-triangle-fill"></i>;
      break;

    case 'secondary':
      icon = <i className="bi bi-exclamation-square"></i>;
      break;

    case 'weather':
      icon = <i className="bi bi-cloud-sun"></i>;
      break;

    case 'info':
    default:
      icon = <i className="bi bi-arrow-right-square"></i>;
      break;
  }

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  const summaryText = title ? title : (getNodeText(children) || "Aviso. Clique para visualizar");

  return (
    <BootstrapAlert
      variant={variant === 'weather' ? 'info' : variant}
      className={`d-flex flex-row gap-2 ${!margin ? 'mt-3' : margin} text-balance` + " " + (className ?? "")}
      role="alert"
      show={show}
      onClose={handleClose}
      dismissible={dismissible}
    >
      <details>
        <summary
          className={"alert-warning-summary list-unstyled"}
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto',
            gap: '0.5rem',
            alignItems: 'center'
          }}
        >
          <span className={"d-block"}>{icon}</span>
          <div className={"text-truncate"}>
            {summaryText}
          </div>
          <span className="d-inline-flex alert-summary-arrow">
            <i className="bi bi-arrow-up-short"></i>
          </span>
        </summary>
        <div className={"mt-3"}>
          {children}
        </div>
      </details>
    </BootstrapAlert>
  );
};

Alert.propTypes = {
  variant: PropTypes.string.isRequired,
  margin: PropTypes.string,
  children: PropTypes.node,
  dismissible: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string
};

export default Alert;
